import React from "react";
import { toast } from "react-toastify";
import apiAgent from "../../../app/api/apiAgent";
import bootbox from "bootbox";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import { OMSNumericBox } from "../../../app/common/common-components/OMSComponent";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSGeoMap } from "../../../app/common/common-components/OMSGeoLocation";
import ConfirmationModalPopup from "../../../app/common/common-components/ModalPopups/ConfirmationModalPopup";
// import { ConfirmationModalProps } from "../../app/models/ModalControlProps/ConfirmationModalProps";

export class CountryAreaBox extends React.Component {
  state = {
    CountryName: this.props.CountryName,
    //showModal: false,
    ProvinceDD: [],
    TownDD: [],
    SuburbDD: [],
    ProvinceID: "",
    TownID: "",
    SuburbID: "",
    MProvinceID: "",
    MProvinceName: "",
    MTownID: "",
    MTownName: "",
    MSuburbID: "",
    MGeoLat: 0,
    MGeoLong: 0,
    MName: "",
    MPostalcode: "",
    MMode: 1,
    ButtonStatus: {
      disabled: false,
      processing_save: false,
      processing_delete: false,
    },
    confirmationModalProps: {},
  };

  constructor(props) {
    super(props);

    this.geoHereMapRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.CountryName != "") {
      this.loadProvincesDDFromServer();
      window
        .$("#SaveModel")
        .off("shown.bs.modal")
        .on(
          "shown.bs.modal",
          function () {
            this.geoHereMapRef.current.loadMap();
          }.bind(this)
        );
    }

    let varConfirmModalProps = {
      showModal: false,
      isConfirmed: (result) => {},
      title: "",
      body: "",
    };
    this.setState({ confirmationModalProps: varConfirmModalProps });
  }

  loadProvincesDDFromServer = () => {
    this.setState({
      ProvinceDD: [],
      TownDD: [],
      SuburbDD: [],
      ProvinceID: "",
      TownID: "",
      SuburbID: "",
    });
    /* var xhr = new XMLHttpRequest();
        xhr.open('get', '/Settings/ProvincesDDAjax?Country=' + this.state.CountryName, true);
        xhr.onload = function () {
          var data = JSON.parse(xhr.responseText);
          this.setState({ ProvinceDD: data });
        }.bind(this);
        xhr.send(); */
    apiAgent.Setting.provincesDDAjax(this.state.CountryName)
      .then((response) => {
        this.setState({ ProvinceDD: response });
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  loadTownsDDFromServer = (ProvinceID) => {
    this.setState({
      ProvinceID: ProvinceID,
      TownDD: [],
      SuburbDD: [],
      TownID: "",
      SuburbID: "",
    });
    /*  var xhr = new XMLHttpRequest();
         xhr.open('get', '/Settings/TownsDDAjax?ProvinceID=' + ProvinceID, true);
         xhr.onload = function () {
           var data = JSON.parse(xhr.responseText);
           this.setState({ TownDD: data });
         }.bind(this);
         xhr.send(); */
    apiAgent.Setting.townsDDAjax(ProvinceID)
      .then((response) => {
        this.setState({ TownDD: response });
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  loadSuburbsDDFromServer = (TownID) => {
    this.setState({ TownID: TownID, SuburbDD: [], SuburbID: "" });
    /* var xhr = new XMLHttpRequest();
        xhr.open('get', '/Settings/SuburbsDDAjax?TownID=' + TownID, true);
        xhr.onload = function () {
          var data = JSON.parse(xhr.responseText);
          this.setState({ SuburbDD: data });
        }.bind(this);
        xhr.send(); */
    apiAgent.Setting.suburbsDDAjax(TownID)
      .then((response) => {
        this.setState({ SuburbDD: response });
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNumericChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  handleProvinceDDChange = (e) => {
    //console.log("Inside handleProvinceDDChange e", e);
    this.setState({ ProvinceID: e.newValue });
    this.loadTownsDDFromServer(e.newValue);
  };

  handleTownDDChange = (e) => {
    this.setState({ TownID: e.newValue });
    this.loadSuburbsDDFromServer(e.newValue);
  };

  handleSuburbDDChange = (e) => {
    this.setState({ SuburbID: e.newValue });
  };

  onCreateProvinceClick = (e) => {
    this.setState({
      MProvinceID: "",
      MMode: 1,
      MProvinceName: "",
      MTownID: "",
      MTownName: "",
      MSuburbID: "",
      MGeoLat: 0,
      MGeoLong: 0,
      MName: "",
      MPostalcode: "",
    });
    this.executeSaveModelClick(0, 0);
  };

  onUpdateProvinceClick = (e) => {
    /* var xhr = new XMLHttpRequest();
        xhr.open('get', '/Settings/SelectProvinceAjax?ProvinceID=' + this.state.ProvinceID, true);
        xhr.onload = function () {
          var data = JSON.parse(xhr.responseText);
          this.setState({ MProvinceID: data.ProvinceID, MMode: 1, MProvinceName: data.Name, MTownID: '', MTownName: '', MSuburbID: '', MGeoLat: data.GeoLat, MGeoLong: data.GeoLong, MName: data.Name, MPostalcode: '' });
          this.executeSaveModelClick(data.GeoLat, data.GeoLong);
        }.bind(this);
        xhr.send(); */
    apiAgent.Setting.selectProvinceAjax(this.state.ProvinceID)
      .then((response) => {
        let data = JSON.parse(response);

        this.setState({
          MProvinceID: data.ProvinceID,
          MMode: 1,
          MProvinceName: data.Name,
          MTownID: "",
          MTownName: "",
          MSuburbID: "",
          MGeoLat: data.GeoLat,
          MGeoLong: data.GeoLong,
          MName: data.Name,
          MPostalcode: "",
        });
        this.executeSaveModelClick(data.GeoLat, data.GeoLong);
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  onCreateTownClick = (e) => {
    var MProvinceName = this.getProvinceDDName();
    this.setState({
      MProvinceID: this.state.ProvinceID,
      MMode: 2,
      MProvinceName: MProvinceName,
      MTownID: "",
      MTownName: "",
      MSuburbID: "",
      MGeoLat: 0,
      MGeoLong: 0,
      MName: "",
      MPostalcode: "",
    });
    this.executeSaveModelClick(0, 0);
  };

  onUpdateTownClick = (e) => {
    var MProvinceName = this.getProvinceDDName();
    /* var xhr = new XMLHttpRequest();
        xhr.open('get', '/Settings/SelectTownAjax?TownID=' + this.state.TownID, true);
        xhr.onload = function () {
            var data = JSON.parse(xhr.responseText);
            this.setState({ MProvinceID: data.ProvinceID, MMode: 2, MProvinceName: MProvinceName, MTownID: data.TownID, MTownName: data.Name, MSuburbID: '', MGeoLat: data.GeoLat, MGeoLong: data.GeoLong, MName: data.Name, MPostalcode: '' });
            this.executeSaveModelClick(data.GeoLat, data.GeoLong);
        }.bind(this);
        xhr.send(); */
    apiAgent.Setting.selectTownAjax(this.state.TownID)
      .then((response) => {
        let data = JSON.parse(response);
        this.setState({
          MProvinceID: data.ProvinceID,
          MMode: 2,
          MProvinceName: MProvinceName,
          MTownID: data.TownID,
          MTownName: data.Name,
          MSuburbID: "",
          MGeoLat: data.GeoLat,
          MGeoLong: data.GeoLong,
          MName: data.Name,
          MPostalcode: "",
        });
        this.executeSaveModelClick(data.GeoLat, data.GeoLong);
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  openCloseDeleteModal = (isOpen) => {
    let varConfirmationModalProps = this.state.confirmationModalProps;
    varConfirmationModalProps.showModal = isOpen;
    this.setState({ confirmationModalProps: varConfirmationModalProps });
  };

  showPopupAndDeleteOnConfirmation = (title, body, callback) => {
    let varConfirmationModalProps = {
      title,
      body,
      showModal: true,
      isConfirmed: function (isConfirmed) {
        if (isConfirmed) {
          callback();
        }
        this.openCloseDeleteModal(false);
      }.bind(this),
    };
    this.setState({ confirmationModalProps: varConfirmationModalProps });
  };

  onDeleteProvinceClick = (e) => {
    let title = "Delete Province?";
    let body = "Do you want to delete province now? This cannot be undone.";
    let callback = this.executeDeleteProvinceClick;
    this.showPopupAndDeleteOnConfirmation(title, body, callback);
  };

  onDeleteTownClick = (e) => {
    let title = "Delete town?";
    let body = "Do you want to delete town now? This cannot be undone.";
    let callback = this.executeDeleteTownClick;
    this.showPopupAndDeleteOnConfirmation(title, body, callback);
  };

  onDeleteSuburbClick = (e) => {
    let title = "Delete suburb?";
    let body = "Do you want to delete suburb now? This cannot be undone.";
    let callback = this.executeDeleteSuburbClick;
    this.showPopupAndDeleteOnConfirmation(title, body, callback);
  };

  executeDeleteProvinceClick = () => {
    //console.log("Inside executeDeleteProvinceClick");
    this.setState({
      ButtonStatus: {
        disabled: true,
        processing_save: false,
        processing_delete: true,
      },
    });

    apiAgent.Setting.deleteProvinceAjax(this.state.ProvinceID, this.state.CountryName)
      .then((response) => {
        if (response.status === "success") {
          //console.log("Inside executeDeleteProvinceClick response:", response);
          this.setState({
            ButtonStatus: {
              disabled: false,
              processing_save: false,
              processing_delete: false,
            },
          });
          this.loadProvincesDDFromServer();
        } else {
          //console.log("Inside executeDeleteProvinceClick error:", response);
          var message = response.message;
          if (message.indexOf("###") != -1) {
            //console.log(message);
            message = "Listings are attached to province, can't delete it.";
          }

          toast.error(message);
          this.setState({
            ButtonStatus: {
              disabled: false,
              processing_save: false,
              processing_delete: false,
            },
          });
        }
      })
      .catch((error) => {});
  };

  executeDeleteTownClick = () => {
    this.setState({
      ButtonStatus: {
        disabled: true,
        processing_save: false,
        processing_delete: true,
      },
    });

    apiAgent.Setting.deleteTownAjax(this.state.ProvinceID, this.state.TownID)
      .then((response) => {
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
        this.loadTownsDDFromServer(this.state.ProvinceID);
      })
      .catch((error) => {
        var message = error.message;
        if (message.indexOf("###") != -1) {
          //console.log(message);
          message = "Listing are attached to town, can't delete it.";
        }

        toast.error(message);
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
      });
  };

  executeDeleteSuburbClick = () => {
    this.setState({
      ButtonStatus: {
        disabled: true,
        processing_save: false,
        processing_delete: true,
      },
    });
    apiAgent.Setting.deleteSuburbAjax(this.state.SuburbID, this.state.TownID)
      .then((response) => {
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
        this.loadSuburbsDDFromServer(this.state.TownID);
      })
      .catch((error) => {
        var message = error.message;
        if (message.indexOf("###") != -1) {
          //console.log(message);
          message = "Listing are attached to suburb, can't delete it.";
        }
        toast.error(message);
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
      });
  };

  onCreateSuburbClick = (e) => {
    var MProvinceName = this.getProvinceDDName();
    var MTownName = this.getTownDDName();
    this.setState({
      MProvinceID: this.state.ProvinceID,
      MMode: 3,
      MProvinceName: MProvinceName,
      MTownID: this.state.TownID,
      MTownName: MTownName,
      MSuburbID: "",
      MGeoLat: 0,
      MGeoLong: 0,
      MName: "",
      MPostalcode: "",
    });
    this.executeSaveModelClick(0, 0);
  };

  onUpdateSuburbClick = (e) => {
    var MProvinceName = this.getProvinceDDName();
    var MTownName = this.getTownDDName();
    /* var xhr = new XMLHttpRequest();
        xhr.open('get', '/Settings/SelectSuburbAjax?SuburbID=' + this.state.SuburbID, true);
        xhr.onload = function () {
            var data = JSON.parse(xhr.responseText);
            this.setState({ MProvinceID: this.state.ProvinceID, MMode: 3, MProvinceName: MProvinceName, MTownID: data.TownID, MTownName: MTownName, MSuburbID: data.SuburbID, MGeoLat: data.GeoLat, MGeoLong: data.GeoLong, MName: data.Name, MPostalcode: data.Postalcode });
            this.executeSaveModelClick(data.GeoLat, data.GeoLong);
        }.bind(this);
        xhr.send(); */
    apiAgent.Setting.selectSuburbAjax(this.state.SuburbID)
      .then((response) => {
        let data = JSON.parse(response);
        this.setState({
          MProvinceID: this.state.ProvinceID,
          MMode: 3,
          MProvinceName: MProvinceName,
          MTownID: data.TownID,
          MTownName: MTownName,
          MSuburbID: data.SuburbID,
          MGeoLat: data.GeoLat,
          MGeoLong: data.GeoLong,
          MName: data.Name,
          MPostalcode: data.Postalcode,
        });
        this.executeSaveModelClick(data.GeoLat, data.GeoLong);
      })
      .catch((error) => {
        console.log("Inside onUpdateSuburbClick Error", error);
        toast.info("Fail");
      });
  };

  executeSaveModelClick = (GeoLat, GeoLong) => {
    window.$("#SaveModel").modal("show");
    setTimeout(
      function () {
        this.geoHereMapRef.current.onLocationChanged(GeoLat, GeoLong);
      }.bind(this),
      2000
    );
  };

  handleModelSubmit = (e) => {
    e.preventDefault();

    if (!this.state.MName.trim()) {
      toast.info("Please enter name");
      return;
    }

    var data = new FormData();

    //console.log("this.state.MProvinceID", this.state.MProvinceID);

    data.append("ProvinceID", this.state.MProvinceID);
    data.append("TownID", this.state.MTownID);
    data.append("SuburbID", this.state.MSuburbID);
    data.append("Country", this.state.CountryName);
    data.append("Name", this.state.MName);
    data.append("GeoLat", this.state.MGeoLat);
    data.append("GeoLong", this.state.MGeoLong);
    data.append("Postalcode", this.state.MPostalcode);

    // for (var key of data.entries()) {
    //     console.log(key[0] + ', ' + key[1]);
    // }

    const formDataObj = Object.fromEntries(data.entries());

    let saveLocationMethod = apiAgent.Setting.saveProvinceAjax;
    if (this.state.MMode === 2) {
      saveLocationMethod = apiAgent.Setting.saveTownAjax;
    } else if (this.state.MMode === 3) {
      saveLocationMethod = apiAgent.Setting.saveSuburbAjax;
    }

    this.setState({
      ButtonStatus: {
        disabled: true,
        processing_save: true,
        processing_delete: false,
      },
    });

   // console.log("saveLocationMethod", saveLocationMethod);

    saveLocationMethod(formDataObj)
      .then((response) => {
        //console.log("Logging response form saveLocation", response);
        window.$("#SaveModel").modal("hide");
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
        if (this.state.MMode === 2) this.loadTownsDDFromServer(this.state.ProvinceID);
        else if (this.state.MMode === 3) this.loadSuburbsDDFromServer(this.state.TownID);
        else this.loadProvincesDDFromServer();
      })
      .catch((error) => {
        toast.info(error.message);
        this.setState({
          ButtonStatus: {
            disabled: false,
            processing_save: false,
            processing_delete: false,
          },
        });
      });
  };

  getProvinceDDName = () => {
    var skillsSelect = document.getElementById("ProvinceDD");
    return skillsSelect.options[skillsSelect.selectedIndex].text;
  };

  getTownDDName = () => {
    var skillsSelect = document.getElementById("TownDD");
    return skillsSelect.options[skillsSelect.selectedIndex].text;
  };

  getModelLabel = () => {
    if (this.state.MMode == 2) {
      if (this.state.MTownID == "") return "Add town for " + this.state.MProvinceName;
      else return "Edit town for " + this.state.MProvinceName;
    } else if (this.state.MMode == 3) {
      if (this.state.MSuburbID == "") return "Add suburb for " + this.state.MTownName;
      else return "Edit suburb for " + this.state.MTownName;
    } else {
      if (this.state.MSuburbID == "") return "Add province for " + this.state.CountryName;
      else return "Edit province for " + this.state.CountryName;
    }
  };

  onGetLocationClick = (e) => {
    var where = this.state.MName;
    if (this.state.MMode == 2) {
      where = this.state.MName + "," + this.state.MProvinceName + "," + this.state.CountryName;
    } else if (this.state.MMode == 3) {
      where = this.state.MName + "," + this.state.MTownName + "," + this.state.MProvinceName + "," + this.state.CountryName;
    } else {
      where = this.state.MName + "," + this.state.CountryName;
    }
    this.geoHereMapRef.current.onSearchAddressLocation(where);
  };

  onHereMapLocationChange = (lat, long) => {
    this.setState({ MGeoLat: lat, MGeoLong: long });
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <ConfirmationModalPopup {...this.state.confirmationModalProps} />
            <div className="form-group">
              <label htmlFor="ProvinceDD">Province</label>
              <OMSDropdown
                id="ProvinceDD"
                options={this.state.ProvinceDD}
                valueField="value"
                labelField="text"
                value={this.state.ProvinceID}
                onChange={this.handleProvinceDDChange}
              />
              {this.state.ProvinceID == "" ? (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateProvinceClick}
                  />
                </div>
              ) : (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateProvinceClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-edit"
                    ui_type="delete"
                    ui_text="Edit"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onUpdateProvinceClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    ui_icon="fa-trash-o"
                    ui_type="delete"
                    ui_text="Delete"
                    ui_processing_text="Deleting.."
                    processing={this.state.ButtonStatus.processing_delete}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onDeleteProvinceClick}
                  />
                </div>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="TownDD">Town</label>
              <OMSDropdown
                id="TownDD"
                options={this.state.TownDD}
                valueField="value"
                labelField="text"
                value={this.state.TownID}
                onChange={this.handleTownDDChange}
              />
              {this.state.ProvinceID == "" ? null : this.state.TownID == "" ? (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateTownClick}
                  />
                </div>
              ) : (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateTownClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-edit"
                    ui_type="delete"
                    ui_text="Edit"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onUpdateTownClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    ui_icon="fa-trash-o"
                    ui_type="delete"
                    ui_text="Delete"
                    ui_processing_text="Deleting.."
                    processing={this.state.ButtonStatus.processing_delete}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onDeleteTownClick}
                  />
                </div>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="Suburb">Suburb</label>
              <OMSDropdown
                id="SuburbDD"
                options={this.state.SuburbDD}
                valueField="value"
                labelField="text"
                value={this.state.SuburbID}
                onChange={this.handleSuburbDDChange}
              />
              {this.state.ProvinceID == "" || this.state.TownID == "" ? null : this.state.SuburbID == "" ? (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateSuburbClick}
                  />
                </div>
              ) : (
                <div style={{ marginTop: 5 }}>
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-plus"
                    ui_type="delete"
                    ui_text="Add"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onCreateSuburbClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-edit"
                    ui_type="delete"
                    ui_text="Edit"
                    ui_processing_text=""
                    processing={false}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onUpdateSuburbClick}
                  />
                  <OMSButtonStyleL
                    type="button"
                    ui_icon="fa-trash-o"
                    ui_type="delete"
                    ui_text="Delete"
                    ui_processing_text="Deleting.."
                    processing={this.state.ButtonStatus.processing_delete}
                    disabled={this.state.ButtonStatus.disabled}
                    onClick={this.onDeleteSuburbClick}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal fade" id="SaveModel" tabIndex={-1} role="dialog" aria-labelledby="SaveModelLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                  ×
                </button>
                <h4 className="modal-title" id="SaveModelLabel">
                  {this.getModelLabel()}
                </h4>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="form-group col-md-12">
                    <label htmlFor="MName">Name</label>
                    <input type="text" name="MName" className="form-control required-control" value={this.state.MName} onChange={this.handleChange} />
                    <div style={{ marginTop: 5 }}>
                      <button type="button" className="btn btn-default" onClick={this.onGetLocationClick}>
                        Get Location
                      </button>
                    </div>
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <label htmlFor="MGeoLat">Geolocation Latitude</label>
                    <OMSNumericBox
                      isDecimal={true}
                      id="MGeoLat"
                      name="MGeoLat"
                      maxLength={20}
                      style={{ width: "150px" }}
                      value={this.state.MGeoLat}
                      placeholder="latitude"
                      onChange={this.handleNumericChange}
                    />
                  </div>
                  <div className="form-group col-md-6 col-sm-12">
                    <label htmlFor="MGeoLong">Geolocation Longitude</label>
                    <OMSNumericBox
                      isDecimal={true}
                      id="MGeoLong"
                      name="MGeoLong"
                      maxLength={20}
                      style={{ width: "150px" }}
                      value={this.state.MGeoLong}
                      placeholder="longitude"
                      onChange={this.handleNumericChange}
                    />
                  </div>
                  {this.state.MMode != 3 ? null : (
                    <div className="form-group col-md-12 col-sm-12">
                      <label htmlFor="MPostalcode">Postalcode</label>
                      <input type="text" name="MPostalcode" className="form-control text-100" value={this.state.MPostalcode} onChange={this.handleChange} />
                    </div>
                  )}
                  <br />
                  <div className="col-md-12">
                    <OMSGeoMap ref={this.geoHereMapRef} onGeoMapChange={this.onHereMapLocationChange} />
                  </div>
                  <br />
                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                  <button type="button" className="btn btn-default" data-dismiss="modal">
                    Close
                  </button>
                  <button type="button" onClick={this.handleModelSubmit} className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
